module.exports = __webpack_public_path__ + "img/SYC.37246351.gif";